<template>
  <nav class="benefits-tabs" :aria-label="t('benefitsCenter-tabs-label')">
    <template v-for="tab in tabs">
      <button v-if="!tab.locked" :key="tab.value" type="button" class="benefits-tab"
        :class="{ active: value === tab.value }" @click="$emit('input', tab.value)">
        {{ t(tab.label) }}
      </button>

      <KvTooltip v-else :key="tab.value" class="benefits-tab-lock-wrap"
        :text="t('benefitsCenter-tabs-comingSoon')" placement="top">
        <span class="benefits-tab is-locked" aria-disabled="true">
          <Icon icon-class="ui-lock-01" size="4" color="#9da4ae" />
          {{ t(tab.label) }}
        </span>
      </KvTooltip>
    </template>
  </nav>
</template>

<script>
import Icon from "../components/icon/icon.vue";
import KvTooltip from "../components/ui/kv-tooltip.vue";

export default {
  name: "BenefitsTabs",
  components: {
    Icon,
    KvTooltip,
  },
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      type: String,
      default: "settings",
    },
  },
  computed: {
    tabs() {
      return [
        { value: "settings", label: "benefitsCenter-tabs-settings" },
        { value: "points", label: "benefitsCenter-tabs-points" },
        { value: "tiers", label: "benefitsCenter-tabs-tiers", locked: true },
        { value: "referrals", label: "benefitsCenter-tabs-referrals", locked: true },
        { value: "cashback", label: "benefitsCenter-tabs-cashback", locked: true },
      ];
    },
  },
  methods: {
    t(term, replaces) {
      return this.$root.t(term, replaces);
    },
  },
};
</script>

<style lang="scss" scoped>
.benefits-tabs {
  align-items: stretch;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow-x: auto;
  scrollbar-width: thin;
  -webkit-overflow-scrolling: touch;
  width: 100%;
}

.benefits-tab-lock-wrap {
  display: flex;
  flex: 1 1 0;
  min-width: 0;
}

.benefits-tab {
  appearance: none;
  background: transparent;
  border: 0;
  border-bottom: 1px solid #9da4ae;
  color: #9da4ae;
  cursor: pointer;
  display: flex;
  flex: 1 1 0;
  gap: 6px;
  align-items: center;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 500;
  justify-content: center;
  line-height: 1.3;
  min-width: 0;
  padding: 16px;
  text-align: center;
  transition: border-color 0.15s ease, color 0.15s ease;
  white-space: nowrap;

  &:hover {
    border-bottom-color: #4d5761;
    color: #4d5761;
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    border-bottom-color: #4d5761;
    color: #4d5761;
  }

  &.active {
    border-bottom-color: #2aaa4c;
    color: #2aaa4c;
  }

  &.active:hover,
  &.active:focus-visible {
    border-bottom-color: #2aaa4c;
    color: #2aaa4c;
  }

  &.is-locked {
    cursor: not-allowed;
    color: #c4c9d0;
    border-bottom-color: #e5e7eb;
    width: 100%;

    &:hover {
      color: #c4c9d0;
      border-bottom-color: #e5e7eb;
    }
  }
}

@media (max-width: 900px) {
  .benefits-tab,
  .benefits-tab-lock-wrap {
    flex: 0 0 auto;
    min-width: max-content;
  }

  .benefits-tab.is-locked {
    width: 100%;
    min-width: max-content;
  }
}

@media (max-width: 480px) {
  .benefits-tab {
    font-size: 14px;
    padding: 12px;
  }
}
</style>
